module.exports = __webpack_public_path__ + "img/logo_sem_fundo.ea3b7858.png";